import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row } from 'reactstrap';
import DragDropComponente from '@componentes/dragdrog/dragdrop.componente';
import ItemKanbam from './Item';
import ModalLocalizacao from '../modais/Localizacao';
import ModalRemover from '../modais/Remover';
import ModalDetalhes from '../modais/Detalhes';
import {
  arquivamentoTipoEmum,
  retornaTipo,
  retornaIcone
} from '../../../arquivamento.utils';
import ArquivamentoApi from '../../../arquivamento.api';
import * as commonActions from '@common/common.action';
import { quadroKanbanEnum, colorsSystem } from '@common/util/defaultValues';
import { arquivamentoStatusEmum } from '../../../arquivamento.utils';
import IntlMessage from '../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

function Kamban ({ lista }, props) {
  const intl = useIntl()
  const dispatch = useDispatch();
  const usuario = useSelector(state => state.usuario);

  const [listaKanbam, setListaKanbam] = useState([]);
  const [listaItens, setListaItens] = useState([]);
  const [showModalLocalizacao, setShowModalLocalizacao] = useState(false);
  const [showModalRemover, setShowModalRemover] = useState(false);
  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [localizacaoArquivamento, setLocalizacaoArquivamento] = useState('');
  const [itemSelecionado, setItemSelecionado] = useState({});

  useEffect(() => {
    const listaFormatada = lista.map(i => ({
      ...i,
      numeroMaterial: `${retornaTipo(i.tipo, intl)} ${i.numeroMaterial}`,
      tipoNome: retornaTipo(i.tipo, intl)
    }));
    setListaItens(listaFormatada);
  }, [lista]);

  useEffect(() => {
    let pendentes = listaItens
      .filter(el => el.status === quadroKanbanEnum.AM_SOLICITADOS.status)
      .map(el =>
        criarItemKanbam(
          el,
          retornaIcone(el.tipo),
          quadroKanbanEnum.AM_SOLICITADOS.status
        )
      );

    let arquivados = listaItens
      .filter(el => el.status === quadroKanbanEnum.AM_ARQUIVADOS.status)
      .map(el =>
        criarItemKanbam(
          el,
          retornaIcone(el.tipo),
          quadroKanbanEnum.AM_ARQUIVADOS.status
        )
      );

    setListaKanbam(getKanbam(pendentes, arquivados));
  }, [listaItens]);

  function criarItemKanbam (item, icone, etapa) {
    let id = `item_${item.laudoArquivosId}_${etapa}`;
    return {
      id: id,
      data: item,
      isDragDisabled: false,
      content: (
        <ItemKanbam
          item={item}
          icone={icone}
          id={id}
          apagar={apagar}
          detalhes={detalhes}
          usuario={usuario}
        />
      )
    };
  }

  function getKanbam (pendentes, arquivados) {
    return [
      {
        pendentes: pendentes,
        title: { text: `${intl.formatMessage({id:"dashboards.reports.materialArchiving"})}`, color: colorsSystem.DG1 },
        count: pendentes.length
      },

      {
        arquivados: arquivados,
        title: { text: `${intl.formatMessage({id:"general.materialArchiving.archived"})}`, color: colorsSystem.DG5 },
        count: arquivados.length
      }
    ];
  }

  function onDragEndOverride (result) {
    const { source, destination } = result;

    var origem = {
      pendentes: quadroKanbanEnum.AM_SOLICITADOS.status,
      arquivados: quadroKanbanEnum.AM_ARQUIVADOS.status
    };

    var itemCard =
      listaKanbam[origem[source.droppableId]][source.droppableId][source.index];
    setItemSelecionado({ ...itemCard.data });

    if (
      destination &&
      destination.droppableId === quadroKanbanEnum.AM_ARQUIVADOS.id
    ) {
      setShowModalLocalizacao(!showModalLocalizacao);
      setLocalizacaoArquivamento('');
    } else {
      salvar({
        ...itemCard.data,
        status: quadroKanbanEnum.AM_SOLICITADOS.status,
        localizacaoArquivamento: ''
      });
    }
  }

  function move (itemMovido) {
    const lista = listaItens.map(item => {
      return item.laudoArquivosId === itemMovido.laudoArquivosId
        ? { ...itemMovido }
        : { ...item };
    });
    setListaItens(lista);
  }

  function salvar (item) {
    setShowModalLocalizacao(false);
    dispatch(commonActions.showFadeCarregando(true));
    ArquivamentoApi.updateArquivamento(item).then(resp => {
      dispatch(commonActions.showFadeCarregando(false));

      if (resp) {
        move(item);
        const message =
          item.tipo === arquivamentoTipoEmum.BLOCO
            ? intl.formatMessage({id: 'general.materialArchiving.blockMoved'})
            : intl.formatMessage({id: 'general.materialArchiving.movedBlade'})
        dispatch(
          commonActions.showAlerta('sucesso', `${message} ${intl.formatMessage({id: 'general.materialArchiving.successfully'})}`, 3000)
        );
      } else {
        const message =
          item.tipo === arquivamentoTipoEmum.BLOCO ? intl.formatMessage({id: 'general.materialArchiving.theBlock'}) : intl.formatMessage({id: 'general.materialArchiving.theBlade'});
        dispatch(
          commonActions.showAlerta(
            'erro',
            `${intl.formatMessage({id: 'general.materialArchiving.details'})} ${message}`,
            3000
          )
        );
      }
    });
  }

  function salvarLocalizacaoKamban () {
    salvar({
      ...itemSelecionado,
      status: arquivamentoStatusEmum.ARQUIVADO,
      localizacaoArquivamento
    });
  }

  function detalhes (item) {
    setItemSelecionado(item);
    setShowModalDetalhes(!showModalDetalhes);
  }

  function apagar (item) {
    setItemSelecionado(item);
    setShowModalRemover(true);
  }

  function removerItem () {
    dispatch(commonActions.showFadeCarregando(true));
    ArquivamentoApi.deleteArquivamento(itemSelecionado.laudoArquivosId).then(
      resp => {
        const lista = listaItens.filter(
          item => item.laudoArquivosId !== itemSelecionado.laudoArquivosId
        );
        setListaItens(lista);

        setShowModalRemover(false);
        dispatch(commonActions.showFadeCarregando(false));
        dispatch(
          commonActions.showAlerta(
            <IntlMessage id="general.materialArchiving.sucess" />,
            <IntlMessage id="general.materialArchiving.successfullyRemoved" />,
            3000
          )
        );
      }
    );
  }

  return (
    <Row>
      <ModalLocalizacao
        onModal={() => setShowModalLocalizacao(!showModalLocalizacao)}
        localizacaoArquivamento={localizacaoArquivamento}
        setLocalizacaoArquivamento={setLocalizacaoArquivamento}
        showModalLocalizacao={showModalLocalizacao}
        salvarLocalizacao={salvarLocalizacaoKamban}
      />
      <ModalRemover
        onModal={() => setShowModalRemover(!showModalRemover)}
        itemSelecionado={itemSelecionado}
        showModalRemover={showModalRemover}
        removerItem={removerItem}
      />
      <ModalDetalhes
        onModal={() => setShowModalDetalhes(!showModalDetalhes)}
        itemSelecionado={itemSelecionado}
        showModalDetalhes={showModalDetalhes}
      />
      <DragDropComponente
        {...props}
        list={listaKanbam}
        onDragEndOverride={onDragEndOverride}
      />
    </Row>
  );
}

export default Kamban;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/Kamban/index.js